var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: _vm.modalId, "data-keyboard": "false" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm.editName === null
                ? _c("div", [
                    _c("h4", { staticClass: "modal-title d-inline-block" }, [
                      _c("b", [_vm._v(_vm._s(_vm.card.name))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      !_vm.lockeddown && !_vm.readonly
                        ? _c("i", {
                            staticClass: "fas fa-pen",
                            staticStyle: {
                              cursor: "pointer",
                              "vertical-align": "top"
                            },
                            attrs: { title: _vm.$t("txtRenameCard") },
                            on: {
                              click: function($event) {
                                _vm.editName = _vm.card.name
                                _vm.$nextTick(function() {
                                  _vm.$refs.editname.focus()
                                })
                              }
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                : _c("div", { staticClass: "input-group mt-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editName,
                          expression: "editName"
                        }
                      ],
                      ref: "editname",
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.editName },
                      on: {
                        keyup: [
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.renameCard.apply(null, arguments)
                          },
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape"
                              ])
                            )
                              return null
                            $event.preventDefault()
                            $event.stopPropagation()
                            _vm.editName = null
                          }
                        ],
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.editName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.renameCard.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("btnRename")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.editName = null
                            }
                          }
                        },
                        [_vm._v("×\n            ")]
                      )
                    ])
                  ]),
              _vm._v(" "),
              _c("small", { staticClass: "idcontainer" }, [
                _vm._v("ID " + _vm._s(_vm.card.id.split("-").slice(-1)[0]))
              ]),
              _vm._v(" "),
              _c("small", { staticClass: "idcontainer" }, [
                _vm._v(" - " + _vm._s(_vm.flow.name))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ml-auto d-flex align-items-center" }, [
                _vm.isAiEnabled
                  ? _c(
                      "button",
                      {
                        staticClass: "btn p-0 mr-4 mt-1 text-muted",
                        staticStyle: { "font-size": "0.85rem" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.askModal.open()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-magic" })]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.close.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-body kanban-stack",
                on: {
                  dragenter: function($event) {
                    _vm.dragging++
                  },
                  dragleave: function($event) {
                    _vm.dragging--
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                    return _vm.canDrop.apply(null, arguments)
                  },
                  drop: function($event) {
                    _vm.dragging = 0
                  }
                }
              },
              [
                _c(
                  "div",
                  { ref: "normallayer", staticClass: "row kanban-stack-layer" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-9" },
                      [
                        _c("details-content", {
                          attrs: {
                            modalId: _vm.modalId,
                            state: _vm.state,
                            board: _vm.board,
                            flow: _vm.flow,
                            card: _vm.card,
                            readonly: _vm.readonly,
                            lockeddown: _vm.lockeddown
                          },
                          on: {
                            "open-system-attributes": function($event) {
                              return _vm.$refs.attributesModal.open({
                                tab: "system"
                              })
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("div", { staticClass: "header" }, [
                          _c("b", [_vm._v(_vm._s(_vm.$t("txtProperties")))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-default btn-outline-secondary mb-1 w-100",
                            attrs: {
                              "data-toggle": "modal",
                              "data-target": "#" + _vm.labelModalId,
                              disabled: _vm.lockeddown || _vm.readonly
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-tags" }),
                            _vm._v(
                              _vm._s(_vm.$t("btnLabels")) + "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-default btn-outline-secondary mb-1 w-100",
                            attrs: {
                              "data-toggle": "modal",
                              "data-target": "#" + _vm.duedateModalId,
                              disabled: _vm.lockeddown || _vm.readonly
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-calendar-alt" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("txtDueDate")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-default btn-outline-secondary mb-1 w-100",
                            attrs: { disabled: _vm.lockeddown || _vm.readonly },
                            on: {
                              click: function($event) {
                                return _vm.$refs.responsibleModal.open()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-user" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("txtResponsibles")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "form",
                          { attrs: { enctype: "multipart/form-data" } },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "btn btn-default btn-outline-secondary btn-file mb-1 w-100",
                                class: {
                                  disabled: _vm.lockeddown || _vm.readonly
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-paperclip" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("btnAttachment")) +
                                    "\n                                  "
                                ),
                                _c("input", {
                                  ref: "fileUploadField",
                                  attrs: { name: "upload", type: "file" },
                                  on: {
                                    change: function($event) {
                                      return _vm.createAttachment()
                                    }
                                  }
                                })
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.canDurations
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-default btn-outline-secondary mb-1 w-100",
                                attrs: {
                                  disabled: _vm.lockeddown || _vm.readonly
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.durationsModal.openModal()
                                  }
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-clock" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("kanbanTimeTracking")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-default btn-outline-secondary mb-1 w-100",
                            attrs: { disabled: _vm.lockeddown || _vm.readonly },
                            on: {
                              click: function($event) {
                                return _vm.$refs.attributesModal.open()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fa fa-asterisk" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("kanbanAttributes")) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "header" }, [
                          _c("b", [_vm._v(_vm._s(_vm.$t("txtActions")))])
                        ]),
                        _vm._v(" "),
                        _vm.state.settings && _vm.state.settings.advancedUi
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-default btn-outline-secondary mb-1 w-100",
                                on: { click: _vm.downloadCardPdf }
                              },
                              [
                                _c("i", { staticClass: "fa fa-file-pdf" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("kanbanPdf")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.state.settings && _vm.state.settings.advancedUi
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-default btn-outline-secondary mb-1 w-100",
                                on: { click: _vm.exportCard }
                              },
                              [
                                _c("i", { staticClass: "fa fa-file-export" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("txtExport")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.state.settings && _vm.state.settings.advancedUi
                          ? _c(
                              "div",
                              { staticClass: "btn-group mb-1 w-100" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-default btn-outline-secondary",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.lockeddown || _vm.readonly
                                    },
                                    on: { click: _vm.publicLinkCard }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-link" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("kanbanPublicLink")) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.card.isPublic
                                  ? [
                                      _c("button", {
                                        staticClass:
                                          "btn btn-default btn-outline-secondary dropdown-toggle dropdown-toggle-split",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false",
                                          id: "detailsPublicButton",
                                          disabled:
                                            _vm.lockeddown || _vm.readonly
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu dowpdown-menu-kanban",
                                          attrs: {
                                            "aria-labelledby":
                                              "detailsPublicButton"
                                          }
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item c-pointer",
                                              on: {
                                                click: _vm.removePublicAccess
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "kanbanRemovePublicAccess"
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "btn-group w-100" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-default btn-outline-secondary mb-1",
                              attrs: {
                                "data-toggle": "modal",
                                "data-target": "#" + _vm.moveModalId,
                                disabled: _vm.lockeddown || _vm.readonly
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-share" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("txtMove")) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-default btn-outline-secondary mb-1",
                              attrs: { disabled: _vm.readonly },
                              on: { click: _vm.copyCard }
                            },
                            [
                              _c("i", { staticClass: "fa fa-copy" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("txtCopy")) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.state.settings && _vm.state.settings.advancedUi
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-default btn-outline-secondary mb-1 w-100",
                                attrs: {
                                  "data-toggle": "modal",
                                  "data-target": "#" + _vm.shareModalId,
                                  disabled: _vm.lockeddown || _vm.readonly
                                }
                              },
                              [
                                _c("i", { staticClass: "fa fa-share" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("txtShare")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.card.archived
                          ? [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default btn-outline-secondary mb-1 w-100",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    disabled: _vm.readonly
                                  },
                                  on: { click: _vm.archive }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-archive" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("txtArchive")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          : [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-default btn-outline-secondary mb-1 w-100",
                                  attrs: {
                                    "data-dismiss": "modal",
                                    disabled: _vm.readonly
                                  },
                                  on: { click: _vm.unarchive }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-archive" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("txtUnarchive")) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                        _vm._v(" "),
                        _vm.canDelete
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-default btn-outline-secondary mb-1 w-100",
                                attrs: {
                                  "data-dismiss": "modal",
                                  disabled: _vm.lockeddown || _vm.readonly
                                },
                                on: { click: _vm.deleteCard }
                              },
                              [
                                _c("i", { staticClass: "fa fa-trash" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("txtDelete")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.readonly
                  ? _c(
                      "div",
                      {
                        ref: "dropzonelayer",
                        staticClass: "row kanban-stack-layer kanban-hide",
                        class: { "kanban-show": _vm.dragging },
                        staticStyle: { background: "#fff", "z-index": "1" }
                      },
                      [
                        _c("dropzone", {
                          staticClass: "w-100 h-100",
                          attrs: {
                            acceptsFileFn: f => true,
                            handleFileFn: _vm.createAttachmentDropzoneFn
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("label-modal", {
                  attrs: {
                    modalId: _vm.labelModalId,
                    state: _vm.state,
                    exclude: _vm.card.cardLabels.map(e => e.label)
                  },
                  on: { addLabel: _vm.addLabel, removeLabel: _vm.removeLabel }
                }),
                _vm._v(" "),
                _c("datetime-modal", {
                  attrs: {
                    modalId: _vm.duedateModalId,
                    datetime:
                      _vm.card.dueDate ||
                      new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        new Date().getDate(),
                        9,
                        0,
                        0
                      )
                  },
                  on: { selected: _vm.duedateChanged }
                }),
                _vm._v(" "),
                _c("move-modal", {
                  attrs: {
                    modalId: _vm.moveModalId,
                    state: _vm.state,
                    board: _vm.board
                  },
                  on: { selected: _vm.boardChanged }
                }),
                _vm._v(" "),
                _c("share-card-modal", {
                  attrs: {
                    modalId: _vm.shareModalId,
                    state: _vm.state,
                    card: _vm.card,
                    sharedWith: _vm.getSharedInfoCard(_vm.state, _vm.card)
                      .accountIds
                  },
                  on: {
                    addCardShared: _vm.addShared,
                    removeCardShared: _vm.removeShared
                  }
                }),
                _vm._v(" "),
                _c("responsible-modal", {
                  ref: "responsibleModal",
                  attrs: {
                    state: _vm.state,
                    responsibles: _vm.card.responsibles
                  },
                  on: {
                    addResponsible: _vm.responsibleAdd,
                    removeResponsible: _vm.responsibleRemove
                  }
                }),
                _vm._v(" "),
                _c("duration-modal", {
                  ref: "durationsModal",
                  attrs: {
                    modalId: _vm.durationsModalId,
                    state: _vm.state,
                    card: _vm.card
                  },
                  on: { save: _vm.durationAdd }
                }),
                _vm._v(" "),
                _c("AttributesEditModal", {
                  ref: "attributesModal",
                  attrs: {
                    state: _vm.state,
                    board: _vm.board,
                    card: _vm.card,
                    saving: _vm.savingAttributes
                  },
                  on: { save: _vm.attributesSave }
                }),
                _vm._v(" "),
                _vm.isAiEnabled
                  ? _c("AskModal", {
                      ref: "askModal",
                      attrs: { jobId: _vm.card.id, jobRequestMode: true }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }